import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import Select from 'react-select';

import WhatsAppTemplateAPI from '../../../api/WhatsAppTemplateAPI';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import LocalStorage from '../../../util/LocalStorage';
import ApiUiController from '../../../controller/ApiUiController';

class WhatsAppTemplateList extends React.Component {

  constructor(props) {
    super(props);
    this.apps = [];
    this.state = { ...this.state, app: {}, popup: false, inApiCall: true };
    this.path = this.props.match.path;

    const model = LocalStorage.getWhatsAppTemplate(LocalStorage.Model);
    this.options = LocalStorage.getApis(LocalStorage.Options);
    this.options = this.options.filter(opt => opt.status = Const.Active && opt.party_type === Const.WhatsApp);
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() {
    if (this.List) WhatsAppTemplateAPI.list(this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = apps => { this.apps = apps; this.setState({ inApiCall: false }); };

  show = i => {
    const app = i === -1 ? { id: 0, ref: '', text: '', body_json: null }
      : {
        id: this.apps[i].id, name: this.apps[i].name, text: this.apps[i].text, ref: this.apps[i].ref,
        api_provider: this.options.find(opt => opt.value === this.apps[i].api_provider),
        body_json: this.apps[i].body_json
      };
    this.setState({ ...this.state, app: { ...app }, popup: true });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.app.name.trim().length === 0) return;

    const app = { ...this.state.app };
    app.name = app.name.trim();
    app.api_provider = app.api_provider ? app.api_provider.value : 0;
    app.text = app.text.trim();

    this.setState({ ...this.state, popup: false, inApiCall: true });
    WhatsAppTemplateAPI.save(app, this.success, this.onFail);
  };
  success = () => WhatsAppTemplateAPI.list(this.onReceived, this.onFail);
  nameChange = val => this.setState({ ...this.state, app: { ...this.state.app, name: val } });
  refChange = val => this.setState({ ...this.state, app: { ...this.state.app, ref: val } });
  providerChange = val => this.setState({ ...this.state, app: { ...this.state.app, api_provider: val } });
  textChange = val => this.setState({ ...this.state, app: { ...this.state.app, text: val } });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.apps[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        WhatsAppTemplateAPI.delete(this.apps[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'WhatsApp Template Deleted successfully', 'success');
    WhatsAppTemplateAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const appUI = this.apps.map((app, _i) => {
      const provider = this.options.find(opt => opt.value === app.api_provider);
      return <tr key={`app_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{app.name}</td>
        <td>{app.ref}</td>
        <td>{provider ? provider.label : ''}</td>
        <td>{app.text}</td>
        <td>{Display.ModelLabelValue('user', app.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(app.created_date)}</td>
        <td>{Display.ModelLabelValue('user', app.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(app.updated_date)}</td>
        <td>
          {this.Update &&
            <span className="buttons success" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update</span>
          }
          {
            app.status !== Const.AlwaysActive && this.Delete &&
            <span onClick={() => this.confirmDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
          }
        </td>
      </tr>;
    });

    return (
      <>
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter"
          show={this.state.popup} onHide={this.hide} centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">WhatsApp Template</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    className="mr-sm-2"
                    value={this.state.app.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Reference/Template Id</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Reference/Template Id"
                    className="mr-sm-2"
                    value={this.state.app.ref}
                    onChange={event => this.refChange(event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>API Provider</Form.Label>
                  <Select
                    value={this.state.app.api_provider}
                    onChange={selected => this.providerChange(selected)}
                    options={this.options}
                    isSearchable={true}
                    isClearable={true} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Message"
                    className="mr-sm-2"
                    value={this.state.app.text}
                    onChange={event => this.textChange(event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Aditional JSON</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Text"
                    className="mr-sm-2"
                    value={this.state.app.body_json}
                    onChange={event => this.setState({ ...this.state, app: { ...this.state.app, body_json: event.target.value } })} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 pb-3"><h3>WhatsApp Templates</h3></div>
              {this.Add &&
                <div className="col-md-8 text-right pb-3">
                  <span className="success buttons pcat" onClick={() => this.show(-1)}>
                    + Add Template</span>
                </div>
              }
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Reference/Template Id</th>
                      <th>Api Provider</th>
                      <th>Message</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th className="actionth">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {appUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(WhatsAppTemplateList);
